import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import { OriginPoint } from '../data/originPoint'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    cards: [{ id: '' }, { id: '' }, { id: '' }]
  },
  mutations: {
    RESET(state) {
      state.cards = [{ id: '' }, { id: '' }, { id: '' }]
    },
    SET_CARDS(state, cards) {
      state.cards = cards
    },
    ADD_CARD(state, card) {
      state.cards.push({ id: '' })
    },
    UPDATE_CARD(state, { index, val }) {
      state.cards.splice(index, 1, val)
    }
  },
  actions: {
    getCards({ state, commit }, cards) {
      return api.fetchCards(cards).then(res => {
        res.data.map(card => {
          let i = state.cards.findIndex(c => c.id === card.id)
          commit('UPDATE_CARD', { index: i, val: card })
        })
      })
    },
    determineWinner({ state, commit }) {
      // create deep copy to not update UI until sorting is done
      // convert eras to numbers

      let OC = state.cards[0]

      let cards = state.cards.map((card, index) => {
        card.point = new OriginPoint(card.year, card.month, card.day)
        card.diff = OC.point.diff(card.point)
        return card
      })
        .sort((a, b) => {
          if (a.diff > b.diff) {
            return 1
          } else if (a.diff < b.diff) {
            return -1
          }
          return 0
        })
      commit('SET_CARDS', cards)

    }
  },
  getAllCards({ state, commit }) {
    return api.fetchAllCards().then(res => {
      res.data.map(card => {
        let i = state.cards.findIndex(c => c.id === card.id)
        commit('UPDATE_CARD', { index: i, val: card })
      })
    })
  }
})
